// frontend/src/hooks/usePerms.ts — per-project permission lookup.
//
// Selects `me.permissions[projectId]` from the cached /me payload (no
// additional network call — the perms ship inside /me per ADR-003 boot-
// essentials). `useQuery(['me'])` with a `select` projection.
//
// Selector is module-level (not inline) so its identity is stable across
// renders — required for TanStack Query's referential-stability contract
// on `select`. The closure over `projectId` is recreated per call, but
// `select` only re-runs when the queryKey result changes, not when the
// closure identity does.
//
// `projectId` is a parameter so this hook has no router dependency.
// Consumers read from `useProjectParams()` (typed wrapper) and pass the
// value here.

import type { UseQueryResult } from '@tanstack/react-query';
import type { ProjectPermissions } from '@ems-app/schemas/auth/responses';
import { useMe } from './useMe.js';

export function usePerms(projectId: string): UseQueryResult<ProjectPermissions | undefined, Error> {
  return useMe((me) => me.permissions[projectId]);
}
